import { AppState } from '../initialStateRegistration';

export const getPrimaryHeader = (state: AppState) => state.primaryHeader;
